var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 28,
    viewBox: "0 0 25 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 13.875C16.1914 13.875 19.25 10.8691 19.25 7.125C19.25 3.43359 16.1914 0.375 12.5 0.375C8.75586 0.375 5.75 3.43359 5.75 7.125C5.75 10.8691 8.75586 13.875 12.5 13.875ZM17.1934 15.5625H16.2969C15.1367 16.1426 13.8711 16.4062 12.5 16.4062C11.1289 16.4062 9.81055 16.1426 8.65039 15.5625H7.75391C3.85156 15.5625 0.6875 18.7793 0.6875 22.6816V24.8438C0.6875 26.2676 1.79492 27.375 3.21875 27.375H21.7812C23.1523 27.375 24.3125 26.2676 24.3125 24.8438V22.6816C24.3125 18.7793 21.0957 15.5625 17.1934 15.5625Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarIcon);
export default __webpack_public_path__ + "static/media/avatar-icon.e79544d2.svg";
export { ForwardRef as ReactComponent };